import { useState } from "react";
import { Navigate, Route, Routes } from "react-router";
import { pdfjs } from "react-pdf";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import LandingPage from "./pages/LandingPage";
import Training from "./pages/Training";
import MobileMenu from "./components/common/MobileMenu";
import ScrollToTop from "./components/containers/ScrollToTop";
import GetInvolved from "./pages/GetInvolved";
import CareerDetails from "./subpages/CareerDetails";
import Evidence from "./pages/Evidence";
import Curriculum from "./pages/Curriculum";
import Programs from "./pages/Programs";
import AboutUs from "./pages/AboutUs";
import Spaces from "./pages/Space";
import { PdfProvider } from "./context/PdfProvider";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "./styles/App.css";
import "./styles/utilities.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function App() {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <PdfProvider>
      <div>
        <ScrollToTop />
        <Header setShowMenu={setShowMenu} />
        <MobileMenu showMenu={showMenu} setShowMenu={setShowMenu} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/training" element={<Training />} />
          <Route path="/get-involved/*" element={<GetInvolved />} />
          <Route path="/space/*" element={<Spaces />} />
          <Route path="/evidence/*" element={<Evidence />} />
          <Route path="/programs/*" element={<Programs />} />
          <Route path="/about-us/*" element={<AboutUs />} />
          <Route path="/curriculum/*" element={<Curriculum />} />
          <Route path="/careers/:id" element={<CareerDetails />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>
    </PdfProvider>
  );
}

export default App;
